import { render, staticRenderFns } from "./Ubah.vue?vue&type=template&id=3f3c0a90"
import script from "./Ubah.vue?vue&type=script&lang=js"
export * from "./Ubah.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports